<div class="step-container">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="step-nav-bar">
    <a id="parentFields" routerLinkActive="active" [routerLink]="['parent-fields']" [queryParams]="{getMultiFields: false}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="merge" mat-tab-link>{{stepName}} Fields</a>
    @if (hasMultiMulti) {
      <a id="multipleEntries" routerLinkActive="active" [routerLink]="['multiple-entries']" [queryParams]="{getMultiFields: true}" [routerLinkActiveOptions]="{ exact: false }" queryParamsHandling="merge" mat-tab-link>Multiple Entries</a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <div class="step-sub-view">
      <router-outlet></router-outlet>
    </div>
  </mat-tab-nav-panel>
</div>